export default __webpack_public_path__ + "static/media/covid.1c4c7c79.jpg";